import { gql } from '@apollo/client';

export const GET_MINISTRIES = gql`
  query GetMinistries {
    ministries: getMinistries {
      id
      name
    }
  }
`;
